"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskSummary = exports.TaskTree = exports.TaskStatus = exports.TaskMessage = exports.TaskStatus_StatusType = exports.TaskMessage_Type = exports.protobufPackage = void 0;
exports.taskMessage_TypeFromJSON = taskMessage_TypeFromJSON;
exports.taskMessage_TypeToJSON = taskMessage_TypeToJSON;
exports.taskStatus_StatusTypeFromJSON = taskStatus_StatusTypeFromJSON;
exports.taskStatus_StatusTypeToJSON = taskStatus_StatusTypeToJSON;
/* eslint-disable */
var long_1 = __importDefault(require("long"));
var minimal_1 = __importDefault(require("protobufjs/minimal"));
var timestamp_1 = require("../../google/protobuf/timestamp");
exports.protobufPackage = "portal.v1";
var TaskMessage_Type;
(function (TaskMessage_Type) {
    TaskMessage_Type[TaskMessage_Type["Undefined"] = 0] = "Undefined";
    TaskMessage_Type[TaskMessage_Type["Error"] = 1] = "Error";
    TaskMessage_Type[TaskMessage_Type["Warning"] = 2] = "Warning";
    TaskMessage_Type[TaskMessage_Type["Info"] = 3] = "Info";
    TaskMessage_Type[TaskMessage_Type["Debug"] = 4] = "Debug";
    TaskMessage_Type[TaskMessage_Type["Trace"] = 5] = "Trace";
    TaskMessage_Type[TaskMessage_Type["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TaskMessage_Type || (exports.TaskMessage_Type = TaskMessage_Type = {}));
function taskMessage_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case "Undefined":
            return TaskMessage_Type.Undefined;
        case 1:
        case "Error":
            return TaskMessage_Type.Error;
        case 2:
        case "Warning":
            return TaskMessage_Type.Warning;
        case 3:
        case "Info":
            return TaskMessage_Type.Info;
        case 4:
        case "Debug":
            return TaskMessage_Type.Debug;
        case 5:
        case "Trace":
            return TaskMessage_Type.Trace;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TaskMessage_Type.UNRECOGNIZED;
    }
}
function taskMessage_TypeToJSON(object) {
    switch (object) {
        case TaskMessage_Type.Undefined:
            return "Undefined";
        case TaskMessage_Type.Error:
            return "Error";
        case TaskMessage_Type.Warning:
            return "Warning";
        case TaskMessage_Type.Info:
            return "Info";
        case TaskMessage_Type.Debug:
            return "Debug";
        case TaskMessage_Type.Trace:
            return "Trace";
        case TaskMessage_Type.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
/** These are listed in order of increasing priority */
var TaskStatus_StatusType;
(function (TaskStatus_StatusType) {
    /** Undefined - Unknown status type */
    TaskStatus_StatusType[TaskStatus_StatusType["Undefined"] = 0] = "Undefined";
    /** Success - The handler has successfully handled a put */
    TaskStatus_StatusType[TaskStatus_StatusType["Success"] = 1] = "Success";
    /** Deleted - The handler has successfully handled a delete */
    TaskStatus_StatusType[TaskStatus_StatusType["Deleted"] = 2] = "Deleted";
    /** Pending - The handler has not yet started handling the task */
    TaskStatus_StatusType[TaskStatus_StatusType["Pending"] = 3] = "Pending";
    /** Unresponsive - The handler does not seem to be responsive */
    TaskStatus_StatusType[TaskStatus_StatusType["Unresponsive"] = 4] = "Unresponsive";
    /** Processing - The handler is currently in progress */
    TaskStatus_StatusType[TaskStatus_StatusType["Processing"] = 5] = "Processing";
    /** Error - The handler has error'ed out */
    TaskStatus_StatusType[TaskStatus_StatusType["Error"] = 6] = "Error";
    TaskStatus_StatusType[TaskStatus_StatusType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TaskStatus_StatusType || (exports.TaskStatus_StatusType = TaskStatus_StatusType = {}));
function taskStatus_StatusTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "Undefined":
            return TaskStatus_StatusType.Undefined;
        case 1:
        case "Success":
            return TaskStatus_StatusType.Success;
        case 2:
        case "Deleted":
            return TaskStatus_StatusType.Deleted;
        case 3:
        case "Pending":
            return TaskStatus_StatusType.Pending;
        case 4:
        case "Unresponsive":
            return TaskStatus_StatusType.Unresponsive;
        case 5:
        case "Processing":
            return TaskStatus_StatusType.Processing;
        case 6:
        case "Error":
            return TaskStatus_StatusType.Error;
        case -1:
        case "UNRECOGNIZED":
        default:
            return TaskStatus_StatusType.UNRECOGNIZED;
    }
}
function taskStatus_StatusTypeToJSON(object) {
    switch (object) {
        case TaskStatus_StatusType.Undefined:
            return "Undefined";
        case TaskStatus_StatusType.Success:
            return "Success";
        case TaskStatus_StatusType.Deleted:
            return "Deleted";
        case TaskStatus_StatusType.Pending:
            return "Pending";
        case TaskStatus_StatusType.Unresponsive:
            return "Unresponsive";
        case TaskStatus_StatusType.Processing:
            return "Processing";
        case TaskStatus_StatusType.Error:
            return "Error";
        case TaskStatus_StatusType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseTaskMessage() {
    return { Level: 0, Message: "" };
}
exports.TaskMessage = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.Level !== 0) {
            writer.uint32(8).int32(message.Level);
        }
        if (message.Message !== "") {
            writer.uint32(18).string(message.Message);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseTaskMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Level = reader.int32();
                    break;
                case 2:
                    message.Message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            Level: isSet(object.Level) ? taskMessage_TypeFromJSON(object.Level) : 0,
            Message: isSet(object.Message) ? String(object.Message) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.Level !== undefined && (obj.Level = taskMessage_TypeToJSON(message.Level));
        message.Message !== undefined && (obj.Message = message.Message);
        return obj;
    },
    create: function (base) {
        return exports.TaskMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseTaskMessage();
        message.Level = (_a = object.Level) !== null && _a !== void 0 ? _a : 0;
        message.Message = (_b = object.Message) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseTaskStatus() {
    return { Id: "", Name: "", Message: undefined, StatusValue: 0, FirstUpdated: undefined, LastUpdated: undefined };
}
exports.TaskStatus = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.Id !== "") {
            writer.uint32(10).string(message.Id);
        }
        if (message.Name !== "") {
            writer.uint32(18).string(message.Name);
        }
        if (message.Message !== undefined) {
            exports.TaskMessage.encode(message.Message, writer.uint32(26).fork()).ldelim();
        }
        if (message.StatusValue !== 0) {
            writer.uint32(32).int32(message.StatusValue);
        }
        if (message.FirstUpdated !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.FirstUpdated), writer.uint32(42).fork()).ldelim();
        }
        if (message.LastUpdated !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.LastUpdated), writer.uint32(50).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseTaskStatus();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.Id = reader.string();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Message = exports.TaskMessage.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.StatusValue = reader.int32();
                    break;
                case 5:
                    message.FirstUpdated = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.LastUpdated = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            Id: isSet(object.Id) ? String(object.Id) : "",
            Name: isSet(object.Name) ? String(object.Name) : "",
            Message: isSet(object.Message) ? exports.TaskMessage.fromJSON(object.Message) : undefined,
            StatusValue: isSet(object.StatusValue) ? taskStatus_StatusTypeFromJSON(object.StatusValue) : 0,
            FirstUpdated: isSet(object.FirstUpdated) ? fromJsonTimestamp(object.FirstUpdated) : undefined,
            LastUpdated: isSet(object.LastUpdated) ? fromJsonTimestamp(object.LastUpdated) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.Id !== undefined && (obj.Id = message.Id);
        message.Name !== undefined && (obj.Name = message.Name);
        message.Message !== undefined && (obj.Message = message.Message ? exports.TaskMessage.toJSON(message.Message) : undefined);
        message.StatusValue !== undefined && (obj.StatusValue = taskStatus_StatusTypeToJSON(message.StatusValue));
        message.FirstUpdated !== undefined && (obj.FirstUpdated = message.FirstUpdated.toISOString());
        message.LastUpdated !== undefined && (obj.LastUpdated = message.LastUpdated.toISOString());
        return obj;
    },
    create: function (base) {
        return exports.TaskStatus.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e;
        var message = createBaseTaskStatus();
        message.Id = (_a = object.Id) !== null && _a !== void 0 ? _a : "";
        message.Name = (_b = object.Name) !== null && _b !== void 0 ? _b : "";
        message.Message = (object.Message !== undefined && object.Message !== null)
            ? exports.TaskMessage.fromPartial(object.Message)
            : undefined;
        message.StatusValue = (_c = object.StatusValue) !== null && _c !== void 0 ? _c : 0;
        message.FirstUpdated = (_d = object.FirstUpdated) !== null && _d !== void 0 ? _d : undefined;
        message.LastUpdated = (_e = object.LastUpdated) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseTaskTree() {
    return { HighestStatus: 0, LastUpdated: undefined, NumChildTasks: 0, Task: undefined, Subtasks: [] };
}
exports.TaskTree = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.HighestStatus !== 0) {
            writer.uint32(8).int32(message.HighestStatus);
        }
        if (message.LastUpdated !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.LastUpdated), writer.uint32(18).fork()).ldelim();
        }
        if (message.NumChildTasks !== 0) {
            writer.uint32(24).int64(message.NumChildTasks);
        }
        if (message.Task !== undefined) {
            exports.TaskStatus.encode(message.Task, writer.uint32(34).fork()).ldelim();
        }
        for (var _i = 0, _a = message.Subtasks; _i < _a.length; _i++) {
            var v = _a[_i];
            exports.TaskTree.encode(v, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseTaskTree();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.HighestStatus = reader.int32();
                    break;
                case 2:
                    message.LastUpdated = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.NumChildTasks = longToNumber(reader.int64());
                    break;
                case 4:
                    message.Task = exports.TaskStatus.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.Subtasks.push(exports.TaskTree.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            HighestStatus: isSet(object.HighestStatus) ? taskStatus_StatusTypeFromJSON(object.HighestStatus) : 0,
            LastUpdated: isSet(object.LastUpdated) ? fromJsonTimestamp(object.LastUpdated) : undefined,
            NumChildTasks: isSet(object.NumChildTasks) ? Number(object.NumChildTasks) : 0,
            Task: isSet(object.Task) ? exports.TaskStatus.fromJSON(object.Task) : undefined,
            Subtasks: Array.isArray(object === null || object === void 0 ? void 0 : object.Subtasks) ? object.Subtasks.map(function (e) { return exports.TaskTree.fromJSON(e); }) : [],
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.HighestStatus !== undefined && (obj.HighestStatus = taskStatus_StatusTypeToJSON(message.HighestStatus));
        message.LastUpdated !== undefined && (obj.LastUpdated = message.LastUpdated.toISOString());
        message.NumChildTasks !== undefined && (obj.NumChildTasks = Math.round(message.NumChildTasks));
        message.Task !== undefined && (obj.Task = message.Task ? exports.TaskStatus.toJSON(message.Task) : undefined);
        if (message.Subtasks) {
            obj.Subtasks = message.Subtasks.map(function (e) { return e ? exports.TaskTree.toJSON(e) : undefined; });
        }
        else {
            obj.Subtasks = [];
        }
        return obj;
    },
    create: function (base) {
        return exports.TaskTree.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseTaskTree();
        message.HighestStatus = (_a = object.HighestStatus) !== null && _a !== void 0 ? _a : 0;
        message.LastUpdated = (_b = object.LastUpdated) !== null && _b !== void 0 ? _b : undefined;
        message.NumChildTasks = (_c = object.NumChildTasks) !== null && _c !== void 0 ? _c : 0;
        message.Task = (object.Task !== undefined && object.Task !== null)
            ? exports.TaskStatus.fromPartial(object.Task)
            : undefined;
        message.Subtasks = ((_d = object.Subtasks) === null || _d === void 0 ? void 0 : _d.map(function (e) { return exports.TaskTree.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseTaskSummary() {
    return { HighestStatus: 0, FirstUpdated: undefined, LastUpdated: undefined, Messages: [] };
}
exports.TaskSummary = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.default.Writer.create(); }
        if (message.HighestStatus !== 0) {
            writer.uint32(8).int32(message.HighestStatus);
        }
        if (message.FirstUpdated !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.FirstUpdated), writer.uint32(18).fork()).ldelim();
        }
        if (message.LastUpdated !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.LastUpdated), writer.uint32(26).fork()).ldelim();
        }
        for (var _i = 0, _a = message.Messages; _i < _a.length; _i++) {
            var v = _a[_i];
            exports.TaskMessage.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseTaskSummary();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.HighestStatus = reader.int32();
                    break;
                case 2:
                    message.FirstUpdated = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.LastUpdated = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.Messages.push(exports.TaskMessage.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            HighestStatus: isSet(object.HighestStatus) ? taskStatus_StatusTypeFromJSON(object.HighestStatus) : 0,
            FirstUpdated: isSet(object.FirstUpdated) ? fromJsonTimestamp(object.FirstUpdated) : undefined,
            LastUpdated: isSet(object.LastUpdated) ? fromJsonTimestamp(object.LastUpdated) : undefined,
            Messages: Array.isArray(object === null || object === void 0 ? void 0 : object.Messages) ? object.Messages.map(function (e) { return exports.TaskMessage.fromJSON(e); }) : [],
        };
    },
    toJSON: function (message) {
        var obj = {};
        message.HighestStatus !== undefined && (obj.HighestStatus = taskStatus_StatusTypeToJSON(message.HighestStatus));
        message.FirstUpdated !== undefined && (obj.FirstUpdated = message.FirstUpdated.toISOString());
        message.LastUpdated !== undefined && (obj.LastUpdated = message.LastUpdated.toISOString());
        if (message.Messages) {
            obj.Messages = message.Messages.map(function (e) { return e ? exports.TaskMessage.toJSON(e) : undefined; });
        }
        else {
            obj.Messages = [];
        }
        return obj;
    },
    create: function (base) {
        return exports.TaskSummary.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseTaskSummary();
        message.HighestStatus = (_a = object.HighestStatus) !== null && _a !== void 0 ? _a : 0;
        message.FirstUpdated = (_b = object.FirstUpdated) !== null && _b !== void 0 ? _b : undefined;
        message.LastUpdated = (_c = object.LastUpdated) !== null && _c !== void 0 ? _c : undefined;
        message.Messages = ((_d = object.Messages) === null || _d === void 0 ? void 0 : _d.map(function (e) { return exports.TaskMessage.fromPartial(e); })) || [];
        return message;
    },
};
var tsProtoGlobalThis = (function () {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function toTimestamp(date) {
    var seconds = date.getTime() / 1000;
    var nanos = (date.getTime() % 1000) * 1000000;
    return { seconds: seconds, nanos: nanos };
}
function fromTimestamp(t) {
    var millis = t.seconds * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
